import React from 'react';
import Navbar from '../components-landing/Navbar';
import Hero from '../components-landing/Hero';
import ClientalSection from '../components-landing/ClientalSection';
import AboutUs from '../components-landing/AboutUs';
import Offerings from '../components-landing/Offerings';
import MainLayout from '../Layouts/MainLayout';
import Features from '../components-landing/Features';
import Pricing from '../components-landing/Pricing';
import Contact from '../components-landing/Contact';
import Footer from '../components-landing/Footer';
import Reviews from '../components-landing/Reviews';
export default function home() {
  return (
    <MainLayout>
      <Navbar />
      <div id="hero">
        <Hero
          title="Win Project Without Spending Hours On Bidding"
          description="Bidzal helps freelancers place smart, relevant bids on projects while saving time and effort. Whether you prefer full control or automated bidding, Bidzal ensures you never miss the right opportunity on freelance platforms."
          ctaText="Get Started Free"
          ctaLink="/login"
        />
      </div>

      <ClientalSection />
      <div id="about"><AboutUs /></div>
      <div id="offerings"><Offerings /></div>
      <div id="features"><Features /></div>
      <div id="pricing"><Pricing /></div>
      <div id="reviews" className='hidden lg:block' ><Reviews /></div>
      <div id="contact"><Contact /></div>
      <div className='h-20'></div>
      <Footer />
    </MainLayout>
  );
}
